import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Grid, Typography } from "@mui/material";
import GamesIcon from "@mui/icons-material/Games";

import { useNotification } from "../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../Hooks/useApiErrorHandler";

import httpclient from "../../../Utils";
import CustomLoadingOverlay from "../../../Components/CustomLoadingOverlay";

import { getColumns } from "./columns";
import StatusChangeConfirmationModal from "./StatusChangeConfirmationModal";
import { useHoldReason } from "../../../Hooks/useHoldReason";

export default function HoldReason() {
  const [selectedReason, setSelectedReason] = useState(null);
  const [changeStatus, setChangeStatus] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [sortModel, setSortModel] = useState([]);
  const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);

  const navigate = useNavigate();
  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();

  const { holdReasons, loading, rowCount, refreshHoldReasons, apiResponse,  } = useHoldReason({
    pagination: paginationModel,
    sorting: sortModel,
  });

  const handleChangeStatus = async () => {
    setChangeStatus(true);
    const API_URL = `/hold-reason/status/${selectedReason.id}`;

    try {
      const { data } = await httpclient.post(API_URL);

      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedReason(null);
        setOpenStatusChangeModal(false);
        refreshHoldReasons(); // Use the hook's refresh function
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      console.log(error, "error changing status");
      handleApiError(error);
    } finally {
      setChangeStatus(false);
    }
  };

  // const handleDelete = async () => {
  //   setActionLoading(true);
  //   const API_URL = `/pack-station/${selectedReason.id}`;

  //   try {
  //     const { data } = await httpclient.delete(API_URL);

  //     if (data.status === 200) {
  //       showNotification("success", data.message);
  //       setSelectedReason(null);
  //       setOpenDeleteModal(false);
  //       refreshHoldReasons(); // Use the hook's refresh function
  //     } else {
  //       showNotification("error", data.message);
  //     }
  //   } catch (error) {
  //     console.log(error, "error deleting station");
  //     handleApiError(error);
  //   } finally {
  //     setActionLoading(false);
  //   }
  // };

  const handleHoldReason = () => {
    navigate("/hold-reason/add");
  };

  const handleEdit = (reason) => {
    setSelectedReason(reason);
    navigate(`/hold-reason/edit/${reason.id}`, {
      state: { reason },
    });
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const columns = getColumns(
    setSelectedReason,
    setOpenStatusChangeModal,
    handleEdit
  );

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          backgroundColor: "#fff",
          padding: "24px 16px",
          borderRadius: "8px",
        }}
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-end"
          mb={2}
        >
          <Grid item xs={12} md={6}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Order Hold Reason
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            gap={2}
          >


            {apiResponse && apiResponse.allow_add === 1 && (
            <Button
              variant="contained"
              sx={{
                borderRadius: "4px",
                backgroundColor: "#7152F3",
                "&:hover": {
                  backgroundColor: "#5c34fa",
                },
              }}
              startIcon={<GamesIcon />}
              onClick={handleHoldReason}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  textTransform: "none",
                }}
              >
                Add New Reason
              </Typography>
            </Button>
            )}
          </Grid>
        </Grid>

        <DataGrid
          rows={holdReasons || []}
          columns={columns}
          autoHeight
          disableRowSelectionOnClick
          loading={loading}
          slots={{
            loadingOverlay: CustomLoadingOverlay,
          }}
          sx={{
            "& .MuiDataGrid-cell": {
              fontSize: "14px",
              fontWeight: 500,
              color: "#48505E",
            },
          }}
          paginationMode="server"
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          sortModel={sortModel}
          rowCount={rowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[20, 50, 100]}
        />
        {openStatusChangeModal && (
          <StatusChangeConfirmationModal
            open={openStatusChangeModal}
            cancel={() => setOpenStatusChangeModal(false)}
            title="Change Status"
            item={selectedReason?.reason_name}
            loading={changeStatus}
            handleChangeStatus={handleChangeStatus}
          />
        )}
        {/* <DeleteConfirmationModal
          open={openDeleteModal}
          cancel={() => setOpenDeleteModal(false)}
          title="Delete Station"
          item={selectedReason?.station_name}
          loading={actionLoading}
          handleDelete={handleDelete}
        /> */}
      </Box>
    </Box>
  );
}
